"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MOTION = {
  default: "220ms",
  "@media (prefers-reduced-motion: reduce)": "0s"
};
const styles = exports.styles = {
  index: {
    flexGrow: "x1iyjqo2",
    minHeight: "x2lwn1j",
    overflowY: "x1odjw0f",
    $$css: true
  },
  indexTitle: {
    paddingTop: "x1mcfnh7",
    $$css: true
  },
  frame: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    flexGrow: "x1iyjqo2",
    minHeight: "x2lwn1j",
    width: "xh8yej3",
    $$css: true
  },
  columns: {
    display: "xrvj5dj",
    gridTemplateColumns: "x1rkzygb x4jmfmw",
    gridTemplateRows: "x5o4joa",
    flexGrow: "x1iyjqo2",
    minHeight: "x2lwn1j",
    $$css: true
  },
  sidebar: {
    boxSizing: "x9f619",
    display: "x78zum5 xkaaz9w",
    flexDirection: "xdt5ytf",
    width: "x9ndnb8",
    height: "x5yr21d",
    minHeight: "x2lwn1j",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    paddingTop: "x6gltce",
    paddingBottom: "x2yie3v",
    paddingLeft: "x79ra4s",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x33uob6",
    borderRightWidth: "xs1s249",
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderRightStyle: "x32b0ac",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderRightColor: "x1e44iqr",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    transitionProperty: "xxrbq2n",
    transitionDuration: "xpceaqw x12w9bfk",
    transitionTimingFunction: "xwji4o3",
    $$css: true
  },
  sidebarMenu: {
    flexGrow: "x1iyjqo2",
    minHeight: "x2lwn1j",
    overflowY: "x1odjw0f",
    overflowX: "x6ikm8r",
    $$css: true
  },
  sidebarCollapsed: {
    width: "xju7ji9",
    $$css: true
  },
  foldButton: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    width: "xvm51jw",
    height: "xwaiz5r",
    flexShrink: "x2lah0s",
    marginTop: "xhj8ucd",
    marginLeft: "x8x9d4c",
    marginInlineStart: null,
    marginInlineEnd: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    color: "xcdm7ny",
    backgroundColor: "xjbqb8w x14sfa1n",
    cursor: "x1ypdohk",
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x2ssjo2",
    $$css: true
  },
  pane: {
    boxSizing: "x9f619",
    minWidth: "xeuugli",
    height: "x5yr21d",
    minHeight: "x2lwn1j",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    $$css: true
  },
  paneBack: {
    paddingLeft: "x9dzeaa",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x52dz5p",
    $$css: true
  },
  paneScrolls: {
    overflowY: "x1odjw0f",
    $$css: true
  },
  paneHandsDown: {
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    $$css: true
  }
};